<template>
  <th class="confetti-table-head-item">
    <div class="head-item">
      <div class="head-item-text">
        {{ columnName }}
      </div>
    </div>
  </th>
</template>

<script>
/*
  NOTE: This component does not have parity with the Ember version as of the
  0.0.0-alpha-6 release.
 */
export default {
  name: "ConfettiTableHeadItem",
  props: {
    columnName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/variables/breakpoints";
@import "confetti/scss/variables/colors";
@import "confetti/scss/variables/typography";
@import "confetti/scss/design/typography";
@import "confetti/scss/tables/confetti-table-head-item";
</style>
